import { JsonProperty, JsonObject } from 'typescript-json-serializer';

@JsonObject()
export class OcpiPartner {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('CredentialsTokenA') tokenA: string;
  @JsonProperty('HasCredentialsTokenB') hasTokenB?: boolean;
  @JsonProperty('HasCredentialsTokenC') hasTokenC?: boolean;
  @JsonProperty('Url') url?: string;
  @JsonProperty('Version') version?: string;
  @JsonProperty('Roles') roles?: OcpiRole[];
  @JsonProperty('Endpoints') endpoints?: OcpiEndpoint[];
  @JsonProperty('CreatedAt') createdAt: Date;
}

@JsonObject()
export class OcpiRole {
  @JsonProperty('Type') type: string;
  @JsonProperty('PartyId') partyId: string;
  @JsonProperty('CountryCode') countryCode: string;
  @JsonProperty('Name') name: string;
}

@JsonObject()
export class OcpiEndpoint {
  @JsonProperty('Identifier') identifier: string;
  @JsonProperty('Role') role: string;
  @JsonProperty('Url') url: string;
}

export interface CreateOcpiPartnerRequest {
  name: string;
}

export interface UpdateOcpiPartnerRequest {
  name: string;
}
